import React from "react";
import { Outlet } from "react-router-dom";
import { Sidebar } from "./Sidebar";

/** Guscio per le pagine a tutta altezza (lettore manuale): barra laterale
 *  Wattline + contenuto pieno, senza topbar né padding. */
export const ManualeShell = () => (
  <div className="min-h-screen flex bg-page">
    <Sidebar mobileOpen={false} onMobileClose={() => {}} />
    <main className="flex-1 min-w-0 h-screen overflow-hidden">
      <Outlet />
    </main>
  </div>
);
